import LegacyApi from '@deezer/legacy-api';
import config from './config';

const legacyApi = new LegacyApi(
	config.get('host_website_ssl').replace(/https?:\/\//, ''),
	{
		mode: 'cors',
		credentials: 'include',
	},
);

let checkFormPromise: Promise<unknown> | null = null;
export const legacyApiCall: typeof legacyApi.call = async (...args) => {
	/**
	 * Our legacy api expects a checkform token to be present in most requests.
	 * The legacyApi lib automatically catches them from backend responses to
	 * send it in later requests. We still need to call a checkform-providing
	 * endpoint (lighter being deezer.checkform, but getUserData works too) once
	 * before any other request to get the token in the first place.
	 *
	 * Ugly fix that access the private field of the legacy api
	 * This is a temporary workaround until we can remove the legacyApi lib entirely.
	 */
	if (!legacyApi['_checkForm']) {
		if (!checkFormPromise) {
			checkFormPromise = legacyApi.call({
				method: 'deezer.checkform',
				data: {
					APP_NAME: 'MusicTogether',
				},
			});
		}
		await checkFormPromise;
	}
	return legacyApi.call(...args);
};
